import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {CustomValidators} from '../../validators';

@Directive({
  selector: '[phoneNumberFormat]',
  providers: [{provide: NG_VALIDATORS, useExisting: PhoneNumberFormatDirective, multi: true}],
})
export class PhoneNumberFormatDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return CustomValidators.phoneNumberFormat(control);
  }
}
